// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__c9TCE","rightSide":"Dashboard_rightSide__x80-M","products":"Dashboard_products__7hZPq"};